export default __webpack_public_path__ + "static/media/jolleria castillo Masaya2.26517acb.jpeg";